module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home/home.component.css
// module id = ./src/app/pages/home/home.component.css
// module chunks = main